import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import shape1 from "../../../Assets/Images/Shape 1.png";
import shape2 from "../../../Assets/Images/Shape 2.png";
import shape3 from "../../../Assets/Images/shapeFive.png";
import shape4 from "../../../Assets/Images/Shape six.png";
import shape5 from "../../../Assets/Images/ShapeSeven.png";
import wrapperIcon from "../../../Assets/Images/Icon Wrapper.png";
import "../AskedQuestion/NewAskedQuestion.css";
import { Link } from "react-router-dom";

// 🔹 Industries data
// Add a hoverIcon property for demonstration (replace with real hover icons if available)
const industries = [
  {
    id: 1,
    title: "Professional Services",
    desc: "We help service firms work to simplify systems, reduce delivery friction, and get technology decisions in line with how teams actually work.",
    icon: "https://i.ibb.co.com/p6QSD6ky/icon-1.png",
  },
  {
    id: 2,
    title: "Telecommunications",
    desc: "We make recommendations in terms of scalability, system reliability and architecture decisions where performance problems rapidly impact thousands of users",
    icon: "https://i.ibb.co.com/d4Mc6Xhb/icon-2.png",
  },
  {
    id: 3,
    title: "Social Media",
    desc: "We support platforms in planning moderation, growth and performance strategies before the user behaviour produces technical and operational strain.",
    icon: "https://i.ibb.co.com/67DWf8tv/icon-3.png",
  },
  {
    id: 4,
    title: "Payments",
    desc: "We advise payment teams on security, integrations, compliance risks, and architecture choices where errors have a direct influence on trust.",
    icon: "https://i.ibb.co.com/8DcX3SDZ/icon-4.png",
  },
  {
    id: 5,
    title: "Hotel Management",
    desc: "We support hotels in evaluating operational softwares, integrations and automation opportunities without upsetting guest experiences.",
    icon: "https://i.ibb.co.com/wht5GbQ2/icon-5.png",
  },
  {
    id: 6,
    title: "E-Commerce",
    desc: "We offer advice on platform performance, checkout flow, integrations and scalability issues during growth phases.",
    icon: "https://i.ibb.co.com/ZRSWDNgg/icon-6.png",
  },
  {
    id: 7,
    title: "Insurance",
    desc: "We support insurers to simplify complex systems, enhance the claims workflow and advance technical bottlenecks that are slowing operations.",
    icon: "https://i.ibb.co.com/gbzz8rXM/icon-7.png",
  },
  {
    id: 8,
    title: "Healthcare",
    desc: "We guide healthcare teams through system decisions that balance privacy, reliability and real world clinical workflows.",
    icon: "https://i.ibb.co.com/Kxqc9zDk/icon-8.png",
  },
  {
    id: 9,
    title: "Food Delivery",
    desc: "We assist delivery platforms in planning out scalable systems, managing peak demand, logistics complexity and real time coordination.",
    icon: "https://i.ibb.co.com/MkTZ9PGm/icon-9.png",
  },
  {
    id: 10,
    title: "Education",
    desc: "We provide advice to education providers on the structure of platforms, user experience and long-term sustainability of learning systems.",
    icon: "https://i.ibb.co.com/p63PmFJ4/icon-10.png",
  },
  {
    id: 11,
    title: "POS System",
    desc: "We help retail businesses assess transaction systems, integrations and reporting safely away from the risk of frontline operations.",
    icon: "https://i.ibb.co.com/B5GYR1jw/icon-11.png",
  },
  {
    id: 12,
    title: "Banking",
    desc: "We help to support banking teams with architecture reviews, risk and technology decisions under strict compliance demands.",
    icon: "https://i.ibb.co.com/Nz6FgLH/icon-12.png",
  },
];

const ServicesSoftConsulIndusAndFQA = () => {
  const [hovered, setHovered] = useState(null);
  // variants: parent controls card transform, child controls sliding-up animation
  const parentVariants = {
    rest: { scale: 1, boxShadow: "0 1px 4px rgba(100, 95, 95, 0.05)", y: 0 },
    hover: {
      scale: 1.02,
      boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
      y: -8,
      transition: { type: "tween", duration: 0.5, ease: "easeOut" },
    },
  };

  const childVariants = {
    rest: {},
    hover: { transition: { staggerChildren: 0.04 } },
  };

  const childItemVariants = {
    rest: { y: 0, opacity: 1 },
    hover: {
      y: -8,
      opacity: 1,
      transition: { duration: 0.18, ease: "easeOut" },
    },
  };
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const visibleIndustries =
    isMobile && !showAll ? industries.slice(0, 7) : industries;
  return (
    <div>
      <section
        id="industries"
        className="py-5 px-5 border-bottom  bg-light"
        style={{
          position: "relative",
          overflow: "visible",
          borderBottom: "1px solid #e6eef0",
          zIndex: "4",
        }}
      >
        {/* decorative gradient - top-right, very low opacity */}
        <img
          className="d-none d-md-flex"
          src={shape1}
          alt="shape 1"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 0,
            right: 0,
            width: "460px",

            zIndex: 0,
            pointerEvents: "none",
          }}
        />
        <img
          className="d-flex d-md-none"
          src={shape3}
          alt="shape 3"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 0,
            right: 0,
            minWidth: "50%",
            minHeight: "10%",

            zIndex: 0,
          }}
        />
        <img
          className="d-flex d-md-none"
          src={shape4}
          alt="shape 3"
          style={{
            opacity: 0.2,
            position: "absolute",
            top: 800,

            minWidth: "50%",
            minHeight: "10%",

            zIndex: 0,
          }}
        />

        {/* left decorative shape (shape2) aligned to the section start and vertically centered */}
        {/* <img className="d-md-none"
          src={shape4}
          alt="shape 2 left"
          style={{
            position: 'absolute',
            left: -8,
            top: '50%',
            transform: 'translateY(-50%)',
            width: isMobile ? 500 : 320,
            maxWidth: isMobile ? '60%' : '52%',
            opacity: isMobile ? 0.14 : 0.06,
            zIndex: 0,
            pointerEvents: 'none',
          }}
        /> */}

        <div
          className="container px-40 text-center"
          style={{ position: "relative", zIndex: 1 }}
        >
          <h2 className="fw-semibold tech-pad-nav Tech-heading  text-black mb-2">
            Industries We Advise When Decisions Get Risky
          </h2>
          <p className="text-muted database-text mb-4">
            Different industries, different pressures. Our consulting focuses on
            helping teams make the right technical decisions before mistakes
            become expensive.
          </p>
          <Link to="/contact-us/build-business">
            <motion.button
              type="button"
              className="data-button px-5 py-3 rounded-pill mb-5"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 30px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{ backgroundColor: "#12869E", boxShadow: "none" }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              style={{ border: "none", color: "#fff", fontSize: "2rem" }}
            >
              Talk To A Consultant
            </motion.button>
          </Link>

          <div className="row gy-5 w-100 w-md-75 gx-6 w-75 mx-auto pb-5">
            {visibleIndustries.map((industry) => (
              <div key={industry.id} className="col-12  col-md-6 col-lg-4">
                <motion.div
                  style={{
                    backgroundColor: hovered === industry.id ? "#fff" : "",
                  }}
                  className=" h-150 w-full border p-3 rounded-4"
                  variants={parentVariants}
                  initial="rest"
                  whileHover="hover"
                  onMouseEnter={() => setHovered(industry.id)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <motion.div
                    className="d-flex px-4 py-4 flex-column align-items-center align-items-md-start text-center text-md-start"
                    style={{
                      height: "260px",
                    }}
                    variants={childVariants}
                  >
                    <motion.div
                      className="rounded-circle mb-3 d-flex align-items-center justify-content-center"
                      variants={childItemVariants}
                      style={{
                        width: "80px",
                        height: "80px",
                        backgroundColor: hovered === industry.id ? "#fff" : "",
                        transition: "background-color  0.3s",
                      }}
                    >
                      {/* Default icon - slide left and fade out when hovered */}
                      <motion.img
                        src={industry.icon}
                        alt={industry.title}
                        style={{
                          width: 68,
                          height: 68,
                          borderRadius: "50%",
                          position: "relative",
                          zIndex: 1,
                        }}
                        animate={{
                          x: hovered === industry.id ? -12 : 0,
                          opacity: hovered === industry.id ? 0 : 1,
                        }}
                        transition={{ duration: 0.12, ease: "easeOut" }}
                      />

                      {/* On hover, slide the fixed image in from the right */}
                      <motion.img
                        src="https://i.ibb.co.com/6cvgH62h/Icon-14.png"
                        alt={industry.title}
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          position: "absolute",
                          zIndex: 4,
                          pointerEvents: "none",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                        initial={{ x: 10, opacity: 0 }}
                        animate={{
                          x: hovered === industry.id ? 0 : 24,
                          opacity: hovered === industry.id ? 1 : 0,
                        }}
                        exit={{ x: 10, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                      />
                    </motion.div>
                    <motion.h5
                      style={{ fontSize: "2.4rem" }}
                      className="text-black    fw-semibold mb-2 "
                      variants={childItemVariants}
                    >
                      {industry.title}
                    </motion.h5>
                    <motion.div variants={childItemVariants}>
                      <p className="text-secondary fqa-text   text-center text-md-start ">
                        {industry.desc}
                      </p>
                    </motion.div>
                  </motion.div>
                </motion.div>
              </div>
            ))}
          </div>
          {/* See more (mobile only) */}
          {isMobile && industries.length > 7 && (
            <div className="text-center mt-3" ref={buttonRef}>
              <button
                className="btn fqa-text text-secondary"
                onClick={() => {
                  if (showAll) {
                    // collapsing
                    setShowAll(false);
                    setTimeout(() => {
                      buttonRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }, 300); // small delay for smooth transition
                  } else {
                    // expanding
                    setShowAll(true);
                  }
                }}
              >
                {showAll ? "See less" : "See more"}
                <span
                  style={{
                    width: "34px",
                    display: "inline-block",
                    transform: showAll ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <img style={{ width: "24px" }} src={wrapperIcon} alt="" />
                </span>
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Place NewAskedQuestion inside the same card, below the top section */}
      <div id="faq" className="" style={{ background: "transparent" }}>
        <section className="faq-section mx-auto ps-md-5 pe-md-5   py-15 just position-relative">
          {/* Left decorative shape */}
          <img
            style={{
              opacity: 0.2,
              position: "absolute",
              top: 180,
              right: 0,
              width: "310px",

              zIndex: 0,
              pointerEvents: "none",
            }}
            src={shape2}
            alt="decorative-shape"
            className="faq-shape 
      d-none d-md-flex"
          />

          <div style={{ zIndex: 2 }} className="container position-relative">
            <div className="faq-box p-4 p-md-5 rounded-3">
              <div className="text-center mb-4 mb-md-5">
                <h2 className="fw-semibold Tech-heading display-6">
                  Questions Teams Ask Before Starting Consulting
                </h2>
                <p className="text-muted heading -tex mb-0">
                  We are more than a generic agency. Explore our Services and
                  our Solutions for your business.
                </p>
              </div>

              <div className="row">
                <div className="col-12 col-lg-10 mx-auto">
                  <div className="accordion custom-accordion" id="faqAccordion">
                    {/* FAQ 1 */}
                    <div className="accordion-item faq-item">
                      <h2 className="accordion-header" id="faqHeadingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faqCollapseOne"
                          aria-expanded="true"
                          aria-controls="faqCollapseOne"
                        >
                          <span className="faq-num me-4 fw-semibold three">
                            01
                          </span>
                          <span className="faq-question  fqa-heading">
                            When should we consider software consulting instead
                            of just building?
                          </span>
                        </button>
                      </h2>
                      <div
                        id="faqCollapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="faqHeadingOne"
                        data-bs-parent="#faqAccordion"
                      >
                        <div
                          className="accordion-body fqa-text text-muted px-3 ms-5 px-md-5"
                          style={{ textAlign: "justify", maxWidth: "85%" }}
                        >
                          Usually when decisions are perceived to be risky and
                          or when things aren't moving forward as quickly.
                          Consulting helps you to stop, figure out what is going
                          on, and not build the wrong thing next.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 2 */}
                    <div className="accordion-item faq-item">
                      <h2 className="accordion-header" id="faqHeadingTwo">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faqCollapseTwo"
                          aria-expanded="false"
                          aria-controls="faqCollapseTwo"
                        >
                          <span className="faq-num me-4 fw-semibold  three">
                            02
                          </span>
                          <span className="faq-question  fqa-heading">
                            Will you look at our existing code and systems?
                          </span>
                        </button>
                      </h2>
                      <div
                        id="faqCollapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="faqHeadingTwo"
                        data-bs-parent="#faqAccordion"
                      >
                        <div
                          className="accordion-body fqa-text text-muted px-3 ms-5 px-md-5"
                          style={{ textAlign: "justify", maxWidth: "85%" }}
                        >
                          Yes. Most consulting work begins with a look at
                          current code, architecture and workflows so
                          recommendations are not based on theory but reality.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 3 */}
                    <div className="accordion-item faq-item">
                      <h2 className="accordion-header" id="faqHeadingThree">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faqCollapseThree"
                          aria-expanded="false"
                          aria-controls="faqCollapseThree"
                        >
                          <span className="faq-num me-4 fw-semibold three">
                            03
                          </span>
                          <span className="faq-question  fqa-heading">
                            Is this only for large or enterprise teams?
                          </span>
                        </button>
                      </h2>
                      <div
                        id="faqCollapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="faqHeadingThree"
                        data-bs-parent="#faqAccordion"
                      >
                        <div
                          className="accordion-body fqa-text text-muted ms-5 px-3 px-md-5"
                          style={{ textAlign: "justify", maxWidth: "85%" }}
                        >
                          Not at all. We are working with startups, growing SaaS
                          teams, and established business, especially when
                          resources are scarce and decisions are more important.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 4 */}
                    <div className="accordion-item faq-item">
                      <h2 className="accordion-header" id="faqHeadingFour">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faqCollapseFour"
                          aria-expanded="false"
                          aria-controls="faqCollapseFour"
                        >
                          <span className="faq-num me-4 fw-semibold three">
                            04
                          </span>
                          <span className="faq-question fqa-heading">
                            Will we get practical next steps or just advice?
                          </span>
                        </button>
                      </h2>
                      <div
                        id="faqCollapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="faqHeadingFour"
                        data-bs-parent="#faqAccordion"
                      >
                        <div
                          className="accordion-body fqa-text text-muted ms-5 px-3 px-md-5"
                          style={{ textAlign: "justify", maxWidth: "85%" }}
                        >
                          You get direction that is clear and actionable. The
                          point is to come away with some decisions taken,
                          priorities made and a plan ahead.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 5 */}
                    <div className="accordion-item faq-item">
                      <h2 className="accordion-header" id="faqHeadingFive">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faqCollapseFive"
                          aria-expanded="false"
                          aria-controls="faqCollapseFive"
                        >
                          <span className="faq-num me-4 fw-semibold three">
                            05
                          </span>
                          <span className="faq-question  fqa-heading">
                            Can consulting turn into development later?
                          </span>
                        </button>
                      </h2>
                      <div
                        id="faqCollapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="faqHeadingFive"
                        data-bs-parent="#faqAccordion"
                      >
                        <div
                          className="accordion-body text-muted fqa-text px-3 ms-5 px-md-5"
                          style={{ textAlign: "justify", maxWidth: "85%" }}
                        >
                          It often does, but it does not have to. Some teams use
                          consulting only for clarity, others continue into
                          implementation once direction is set.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <img
            className="d-flex d-md-none"
            src={shape5}
            alt="shape 5"
            style={{
              opacity: 0.2,
              position: "absolute",
              left: 220,
              right: 0,
              bottom: 4,
              minWidth: "50%",
              minHeight: "15%",
              zIndex: 0,
            }}
          />
        </section>
      </div>
    </div>
  );
};

export default ServicesSoftConsulIndusAndFQA;
